<template>
    <div class="fontBox animate__animated animate__zoomIn" :style="{left:leftMargin,top:topMargin}" v-if="isShow">
      <h3>{{title}}</h3>
      <p>{{txt}}</p>
    </div>
</template>
<script>
import { ref, onMounted } from "vue";

export default {
  name: "baseBar",
  props:['title','txt','leftMargin','topMargin','isShow'],
  setup(props) {

    onMounted(() => {
     
      
    });
    function hiddlen(){

    }
    return {
      hiddlen
    };
  },
};

</script>
<style lang="less" scoped>
    .fontBox{
      position: absolute;
      top: 0;
      background:rgba(3,25,56,.8);
      border: 1px solid #056EBA;
      z-index: 999;
      width: 650px;
      // height: 500px;
      color: rgba(255,255,255,1);
      font-size: 36px;
      padding: 20px 50px 80px;
      line-height: 60px;
      // z-index: 999;
      text-align: left;
      h3{
        text-align: center;
        font-size: 40px;
        margin-bottom: 10px;
        font-weight: normal;
      }
      p{
        text-indent: 2em;
      }
    }
</style>
